import { createSlice } from '@reduxjs/toolkit';

const translationSlice = createSlice({
  name: 'translations',
  initialState: {
    resources: {},
    currentLanguage: localStorage.getItem('language') || 'ar',
    loading: false,
    error: null
  },
  reducers: {
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
    loadTranslationsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    loadTranslationsSuccess: (state, action) => {
      const { language, translations } = action.payload;
      state.resources[language] = { translation: translations };
      state.loading = false;
    },
    loadTranslationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  setLanguage,
  loadTranslationsRequest,
  loadTranslationsSuccess,
  loadTranslationsFailure
} = translationSlice.actions;

export default translationSlice.reducer;